import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import common from 'ui-react-common';
import _ from 'lodash';

import { actionCreator, stateSelectors } from '../../redux';
import formInputs from '../../../../components/form-inputs';

const getReferralData = common.ui.components.routing.getReferralData;
const DeviceService = common.services.DeviceService;
const { Form } = common.ui.components.forms;
const { Divider, Stack, Type: { DisplayFive } } = common.ui.components;
const { Item } = Stack;
const {
    EmailWithConfirmation,
    SocialSecurity,
    AnnualGrossIncome,
    Birthdate,
    PhoneNumber,
} = common.ui.components.forms.configured;

const { Disclosures, disclosureTypes } = formInputs.disclosures;
const {
    LoanPurpose,
    HomeOwnership,
    Address,
    FirstName,
    LastName,
    Recaptcha,
    ContinueButton,
    EmploymentStatus
} = formInputs;

export class ApplicationForm extends Component {
    constructor(params) {
        super(params);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.state = {
            clientResidentState: '',
            loanPurpose: _.get(this.props, 'queryParams.loanPurpose', undefined)
        };

        this.apply = this.apply.bind(this);
    }

    componentDidMount() {
        DeviceService.setBlackBoxId();
    }

    parseForm(formValues) {
        const {
            socialSecurity,
            disclosures,
            phone,
        } = formValues;
        formValues.birthdate = Birthdate.parseBirthday(formValues);
        formValues = Birthdate.clearForm(formValues);
        formValues.phone = PhoneNumber.cleanValue(phone);
        formValues.socialSecurity = SocialSecurity.cleanValue(socialSecurity);
        formValues.disclosures = disclosures[0] === 'disclosures';
        formValues.blackboxId = window.localStorage.getItem('blackboxId') || ';';
        formValues.deviceFingerprint = window.localStorage.getItem('blackboxId') || ';';

        return formValues;
    }

    apply(e, formState) {
        const { queryParams, apply, nonRLClientWithRAID=false } = this.props;
        const qs = getReferralData(queryParams, document.referrer, localStorage);
        const parsedForm = this.parseForm(formState.getValues());
        const pFieldData = formState.pFields && formState.pFields.length ? { pFields: formState.pFields } : {};
        const completeFormData = Object.assign({}, parsedForm, qs, pFieldData, { nonRLClientWithRAID });

        apply(completeFormData);
    }

    handleFormChange(elementKey, elementData, formState) {
        const { state: residentState } = formState.getValues();
        if (residentState) {
            this.setState({
                clientResidentState: residentState
            });
        }
        if (elementKey === 'loanPurpose') {
            this.setState({ loanPurpose: elementData.value });
        }
    }

    render() {
        const { applying } = this.props;
        const helper = this.state.loanPurpose === 'business' ? 'A Rocket Loans business loan is an individual personal loan for business expenses, and as such is not guaranteed by the Small Business Administration.' : '';
        return (
            <Form
                id="applicationForm"
                name="applicationForm"
                onChange={this.handleFormChange.bind(this)}
                onSubmit={this.apply}
                trackPFields={true}
            >
                <div className="formContainer">
                    <DisplayFive className="sprk-u-FontWeight--bold sprk-u-pbs">
                        Let's get started. What are you looking for today?
                    </DisplayFive>
                    <Stack>
                        <Item>
                            <LoanPurpose
                                value={this.state.loanPurpose}
                                helper={helper}
                            />
                        </Item>
                    </Stack>

                    <Divider className="sprk-u-MarginBottom--b sprk-u-mtm"/>

                    <DisplayFive className="sprk-u-FontWeight--bold sprk-u-pbs">
                        Tell us a little about yourself.
                    </DisplayFive>
                    <Stack splitAt="small">
                        <Item breakpoint="small" width="half">
                            <FirstName />
                        </Item>
                        <Item breakpoint="small" width="half">
                            <LastName />
                        </Item>
                    </Stack>
                    <Stack>
                        <Item>
                            <Address />
                        </Item>
                    </Stack>
                    <Stack>
                        <Item>
                            <HomeOwnership />
                        </Item>
                    </Stack>
                    <Stack splitAt="small">
                        <Item breakpoint="small" width="half">
                            <EmploymentStatus />
                        </Item>
                        <Item breakpoint="small" width="half">
                            <AnnualGrossIncome/>
                        </Item>
                    </Stack>
                    <Stack>
                        <Birthdate>
                            <SocialSecurity />
                        </Birthdate>
                    </Stack>

                    <Divider className="sprk-u-MarginBottom--b sprk-u-mtm"/>

                    <DisplayFive className="sprk-u-FontWeight--bold sprk-u-pbs">
                        What's the best way to reach you?
                    </DisplayFive>
                    <Stack>
                        <Item>
                            <PhoneNumber />
                        </Item>
                    </Stack>
                    <Stack className="sprk-u-pbm">
                        <Item>
                            <EmailWithConfirmation />
                        </Item>
                    </Stack>

                    <Stack>
                        <Item>
                            <Disclosures type={disclosureTypes.accountCreation} clientResidentState={this.state.clientResidentState} />
                        </Item>
                    </Stack>
                    <Stack>
                        <Recaptcha />
                    </Stack>
                    <Stack>
                        <Item className="sprk-o-Box--tiny">
                            <ContinueButton
                                id="seeMyOptionsButton"
                                text="See My Options"
                                loading={applying}
                                showCreditWarning
                            />
                        </Item>
                    </Stack>
                </div>
            </Form>
        );
    }
}

ApplicationForm.defaultProps = {
    applying: false,
    queryParams: {},
    nonRLClientWithRAID: false,
};

ApplicationForm.propTypes = {
    applying: PropTypes.bool,
    apply: PropTypes.func.isRequired,
    queryParams: PropTypes.object,
    nonRLClientWithRAID: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    form: stateSelectors.getForm(state),
    code: stateSelectors.getCode(state),
    applying: stateSelectors.getApplying(state),
});

const mapDispatchToProps = (dispatch) => ({
    apply: (data) => dispatch(actionCreator.apply(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ApplicationForm);
